import con from '../../../../../connection';
import files from './files';
var path = '/requests';
var requests = function (url) { return function (request_id) { return ({
    files: files("" + url + path + "/" + (request_id || '')),
    post: function (param) { return con.post(url + path, param); },
}); }; };
export default requests;
